export default {
	namespaced: true,
	state: {
		title: '',
		isTitleSet: false,
	},
	actions: {
		setTitle({ commit, state }, title) {
			if (!state.isTitleSet) {
				commit('SET_TITLE', title);
				commit('SET_TITLE_SET', true);
				document.title = title;
			}
		},
		unsetTitle({ commit }) {
			commit('SET_TITLE', '');
			commit('SET_TITLE_SET', false);
		},
	},
	mutations: {
		SET_TITLE: (state, title) => {
			state.title = title;
		},
		SET_TITLE_SET: (state, value) => {
			state.isTitleSet = value;
		},
	},
};
